import loadable from '@loadable/component';

export const MainViewUserProfilePageLoadable = loadable(
  () => import('./MainViewUserProfilePage.dynamic'),
);
